import React, { useState, useEffect, Fragment } from 'react';
import CommonInput from '../CommonComponent/CommonInput';
import { ThrowError } from '../../constants/ThrowError';
import { useFormikContext } from 'formik';
import fincityLogo123 from '../../../images/consumer/fincityLogo123.svg';
import * as _ from 'lodash';
import { validate as validatePhoneNumber } from '../../constants/PhoneNumberValidation';
import {
  passwordValidation,
  validationMessage,
  passwordRequirments,
} from '../../../components/PasswordValidation/PasswordValidation';
import Error from '../Error/Error';
import {
  MobileInputField,
  useWindowResize,
  CommonCheckbox,
} from '@fincity-frontend/shared-ui';
import GlobalHorizontalMenu from '../GlobalHorizontalMenu/GlobalHorizontalMenu';
import { showHidePassword } from '../../components/ShowHidePassword/ShowHidePassword';
import { useQueryParams, NumberParam, StringParam } from 'use-query-params';
import { getInviteDetails, submitConsent } from '../../../common/constants/api';
import Eye from '../../../images/icons/eye (1).svg';
import CloseEye from '../../../images/icons/slashEye.svg';
import leftHome from '../../../images/consumer/leftHome.png';
import leftHome2x from '../../../images/consumer/leftHome@2x.png';
import mbTop from '../../../images/consumer/mbTop.svg';
import ForgotPassword from '../../../containers/ForgotPasswordFlow/index';
import ConsentFlow from '../../../pages/campaign/index';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import './RegisterForm.css';
import { TruCaller } from '@fincity-frontend/shared-ui';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
const RegisterForm = ({ consumer }) => {
  const [highlightedOpt, setHighlightedOpt] = useState(0);
  const [menuArr, setMenuArr] = useState(['Sign in', 'Sign Up']);
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  const [mobile, setMobile] = useState('');
  const [showForgotPassword, setForgotPassword] = useState(false);
  const [invitevalues, setInvite] = useQueryParams({
    request: StringParam,
  });
  const [showMore, setShowMore] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isItOnlyConsentFlow, setIsItOnlyConsentFlow] = useState(false);
  const [managerDetailsConsent, setManagerDetails] = useState(null);
  const [userDetails, setUserDetails] = useState('');
  const [windowWidth, windowHeight] = useWindowResize();
  const [istruCallerPresent, setIsTrueCallerPresent] = useState(undefined);
  const [showTrucaller, setShowTrucaller] = useState(false);
  const [showPasswordTooltip, setShowPasswordTooltip] = useState(false);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldValue,
    validateForm,
    setFieldTouched,
    resetForm,
    handleSubmit,
  } = useFormikContext();

  useEffect(() => {
    setShowTrucaller(true);
  }, []);

  const handleTruCallerData = (data) => {
    setFieldValue('firstName', data?.name?.firstName);
    setFieldValue('lastName', data?.name?.lastName);
    if (`${data?.mobileNumber}`.length > 10) {
      let splitsValue = [...`${data?.mobileNumber}`];
      let validMobNo = splitsValue?.splice(2)?.toString();
      let stringMobNo = validMobNo?.replace(/,/g, '');
      setFieldValue('mbNo', stringMobNo);
    }
    setFieldValue('email', data?.emailId);
    setFieldValue('isVerifiedByTruCaller', true);
  };
  useEffect(() => {
    if (invitevalues?.request) {
      getInviteDetails(invitevalues?.request)
        .then((res) => {
          if (res) {
            setUserDetails(res || '');
            if (res?.action === 'CREDIT_REPORT_CONSENT') {
              setManagerDetails(res?.consumerDetails?.managerDetail || null);
              setIsItOnlyConsentFlow(true);
            }
            setDisable(true);
            setFieldValue('step', 'signUp', true);
            setHighlightedOpt(1);
            setFieldValue('email', res?.consumerDetails?.email, true);
            setFieldValue('firstName', res?.consumerDetails?.firstName, true);
            setFieldValue('lastName', res?.consumerDetails?.lastName, true);
            setFieldValue('panNo', res?.consumerDetails?.panNumber, true);
            setFieldValue('mbNo', res?.consumerDetails?.phone, true);
            localStorage.setItem(
              'action',
              JSON.stringify({
                nextAction: res?.action,
                requestId: invitevalues?.request,
                phone: res?.consumerDetails?.phone,
              })
            );
          }
        })
        .catch((err) => {});
    } else {
      localStorage.removeItem('action');
    }
  }, []);

  useEffect(() => {
    setFieldValue('mbNo', mobile, false);
    validateForm();
  }, [mobile]);
  const MenuOnclickHandler = (i = 0) => {
    if (i === 0) {
      setFieldValue('step', 'login', true);
    }
    if (i === 1) {
      if (!invitevalues) resetForm();
      setFieldValue('step', 'signUp', true);
    }
  };
  const inputLength = values.mbNo.length;
  const firstDigitModified =
    values.mbNo.length > 0 && !/[6-9]|\./.test(values.mbNo[0]);

  return (
    <div
      autoComplete="off"
      className={`bg-tealCol-200 relative h-full font-roboto text-sm font-normal m-0 p-0 min-h-screen overscroll-auto `}
    >
      <div className="block md:hidden fixed top-0 right-0 ">
        <img src={mbTop} alt="" />
      </div>
      <div className="flex flex-row w-full h-full z-0">
        <div
          className="flex-shrink hidden md:block "
          style={{
            width: '46%',
          }}
        >
          <img
            className="object-cover w-9/12  "
            src={leftHome}
            alt="welcome"
            srcSet={leftHome2x}
            style={{ position: 'fixed', bottom: 0, right: '42%' }}
          />
        </div>

        {/* flow If its a consentFlow i.e action==='CREDIT_REPORT_CONSENT' */}

        <div className="flex-shrink-0 z-10 w-full md:w-27/50  ">
          {/* login/signUp */}

          <div
            className={
              (values.step !== 'signUp' ? 'login' : 'signup  ') +
              ' outerDiv0192 w-full md:w-11/12 md:max-w-lg relative bg-white mt-7 mb-0 md:my-14 pt-4  md:pb-25 md:pb-9 md:pt-7  md:ml-auto md:mr-17 z-10 font-roboto font-normal  overscroll-contain  '
            }
          >
            {!isItOnlyConsentFlow && (
              <div
                className=" mx-auto  mb-8 md:mb-4 hidden md:block"
                style={{ width: 'fit-content' }}
              >
                <img className="block" src={fincityLogo123} alt="Fincity" />
              </div>
            )}

            {isItOnlyConsentFlow ? (
              <ConsentFlow
                userDetails={userDetails}
                consentFlow
                managerDetailsConsent={managerDetailsConsent}
                requestId={invitevalues?.request}
                submitApi={submitConsent}
              />
            ) : !showForgotPassword ? (
              <Fragment>
                <div className=" fitContent mx-auto mb-5 md:mb-7  w-full ">
                  <GlobalHorizontalMenu
                    setHighlightedOpt={setHighlightedOpt}
                    highlightedOpt={highlightedOpt}
                    onClick={MenuOnclickHandler}
                    menuArr={[...menuArr]}
                  />
                </div>
                <div
                  autoComplete="off"
                  className=" grid  gap-y-1 w-full h-90 md:h-90 mx-auto text-left px-4"
                  style={{ maxWidth: '352px' }}
                >
                  {values.step === 'signUp' && (
                    <div className="name_field ">
                      <div className="grid_input_container mb-4">
                        <div>
                          <CommonInput
                            name="firstName"
                            id="firstName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.firstName}
                            stylesContainer={{
                              height: '52px',
                              maxWidth: '100%',
                            }}
                            legendName="First Name"
                            error={touched.firstName && errors.firstName}
                            errorMsg={errors.firstName}
                            touched={touched.firstName}
                            disabled={disable}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {values.step === 'signUp' && (
                    <div className="name_field ">
                      <div className="grid_input_container mb-4">
                        <div>
                          <CommonInput
                            name="lastName"
                            id="lastName"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.lastName}
                            stylesContainer={{
                              height: '52px',
                              maxWidth: '100%',
                            }}
                            legendName="Last Name"
                            error={touched.lastName && errors.lastName}
                            touched={touched.lastName}
                            disabled={disable}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {values.step === 'login' ? (
                    <Fragment>
                      <div className="mobile_field ">
                        <div className="grid_input_container relative mb-2">
                          <MobileInputField
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setMobile={setMobile}
                            validatePhoneNumber={(e) => {
                              validatePhoneNumber(e, inputLength);
                            }}
                          />
                        </div>
                      </div>

                      {/* checking the first Digit the input */}
                      {firstDigitModified ? (
                        <div>
                          <p className=" text-red-100 text-sm font-roboto">
                            First digit cant be {values.mbNo[0]}
                          </p>
                        </div>
                      ) : null}
                      <Error touched={touched.mbNo} message={errors.mbNo} />
                    </Fragment>
                  ) : (
                    <div className="mobile_field ">
                      <div className="grid_input_container relative mb-4">
                        <div
                          style={{ marginTop: '17px' }}
                          className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                        >
                          +91
                        </div>
                        <div>
                          <CommonInput
                            name="mbNo"
                            id="mbNo"
                            maxLength={10}
                            onChange={(e) => {
                              if (!values?.isVerifiedByTruCaller)
                                handleChange(e);
                            }}
                            onBlur={handleBlur}
                            value={values.mbNo}
                            stylesContainer={{
                              height: '52px',
                              maxWidth: '100%',
                            }}
                            inputStyle={{
                              paddingLeft: '45px',
                              letterSpacing: '1px',
                            }}
                            onBlurStyle={{
                              paddingLeft: '20px',
                            }}
                            legendStyle={{
                              paddingLeft: errors.mbNo ? '20px' : '20px',
                            }}
                            legendName="Mobile Number"
                            error={touched.mbNo && errors.mbNo}
                            className={`pt-24`}
                            touched={touched.mbNo}
                            onKeyPress={(e) => {
                              validatePhoneNumber(e, inputLength);
                            }}
                            disabled={disable}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {consumer && values.step === 'signUp' && (
                    <div>
                      <div className="grid_input_container mb-4">
                        <div>
                          <CommonInput
                            name="panNo"
                            id="panNo"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.panNo}
                            stylesContainer={{
                              height: '52px',
                              maxWidth: '100%',
                            }}
                            legendName="PAN Number"
                            error={touched.panNo && errors.panNo}
                            disabled={disable}
                            touched={touched.panNo}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {values.step === 'signUp' && (
                    <div className="email_field ">
                      <div className="grid_input_container mb-4">
                        <div>
                          <CommonInput
                            name="email"
                            id="email"
                            type="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            stylesContainer={{
                              height: '52px',
                              maxWidth: '100%',
                            }}
                            legendName="Email ID"
                            error={touched.email && errors.email}
                            touched={touched.email}
                            disabled={disable}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {values.step === 'login' && (
                    <Fragment>
                      <label className="block mt-6 relative mb-2">
                        <span className=" block text-xs capitalize">
                          Password
                        </span>
                        <div className="">
                          <div className="outer-div flex w-full ">
                            <input
                              className=" showHide flex-1 placeholder-grey-placeholder form-input  rounded-sm mt-1  block w-full"
                              type="password"
                              id="password"
                              name="password"
                              placeholder="**********"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={(e) => {
                                handleBlur(e);
                              }}
                              value={values.password}
                              required
                              minLength="8"
                              maxLength="15"
                            />

                            {/* showHidePassword */}
                            <img
                              className="absolute right-0 mt-2 h-8 w-10 pr-4"
                              onClick={() => {
                                showHidePassword();
                                setShowEyeIcon(!showEyeIcon);
                              }}
                              id="toggle"
                              src={showEyeIcon ? CloseEye : Eye}
                              alt="showPassword"
                            />

                            {/* showHidePassword */}
                            <img
                              className="absolute right-0 mt-2 h-8 w-10 pr-4"
                              onClick={() => {
                                showHidePassword();
                                setShowEyeIcon(!showEyeIcon);
                              }}
                              id="toggle"
                              src={showEyeIcon ? CloseEye : Eye}
                              alt="showPassword"
                            />
                          </div>
                        </div>
                      </label>
                      <Error
                        touched={touched.password}
                        message={errors.password}
                      />
                    </Fragment>
                  )}

                  {values.step === 'signUp' && (
                    <div className="password_field ">
                      <div className="grid_input_container mb-4">
                        <div>
                          <CommonInput
                            name="password"
                            id="password"
                            type="password"
                            onChange={handleChange}
                            onBlur={(e) => {
                              handleBlur(e);
                              setFieldValue('passwordFiledFocused', false);
                            }}
                            onFocus={() =>
                              setFieldValue('passwordFiledFocused', true)
                            }
                            value={values.password}
                            stylesContainer={{
                              height: '52px',
                              maxWidth: '100%',
                            }}
                            legendName={
                              <p className="flex gap-x-1">Set Password</p>
                            }
                            error={touched?.password && errors?.password}
                            touched={touched?.password}
                            rightDiv={
                              <ClickAwayListener
                                onClickAway={() =>
                                  setShowPasswordTooltip(false)
                                }
                              >
                                <span
                                  onClick={() => setShowPasswordTooltip(true)}
                                  className={`cursor-pointer`}
                                >
                                  <Tooltip
                                    title={passwordRequirments}
                                    interactive={true}
                                    open={showPasswordTooltip}
                                    arrow
                                  >
                                    <HelpIcon className="w-10 -mt-1" />
                                  </Tooltip>
                                </span>
                              </ClickAwayListener>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {values.step === 'login' && (
                    <div className="flex flex-row my-5 mx-2 text-sm justify-between">
                      <div
                        className="text-red-500 cursor-pointer ml-auto"
                        onClick={async () => {
                          setFieldValue('isForgotPassword', true, true);
                          setForgotPassword(true);
                        }}
                      >
                        Forgot password?
                      </div>
                    </div>
                  )}

                  {/* consent */}

                  {values.step === 'signUp' && (
                    <div className="relative h-full w-full inline-flex flex-row   mt-1 items-center ">
                      <div
                        className="absolute w-1/5 "
                        style={{
                          height: '100%',
                          backgroundColor: '#FD80231C',
                        }}
                      ></div>
                      <CommonCheckbox
                        containerStyles={{
                          position: 'absolute',
                          ...(windowWidth > 400
                            ? { left: '5%' }
                            : windowWidth > 300
                            ? { left: '1%' }
                            : { left: '-2%' }),
                        }}
                        inputStyles={{
                          width: '24px',
                          height: '24px',
                          marginTop: '-10px',
                          marginLeft: '12px',
                          ...(!values?.permission
                            ? {
                                border: '2px solid #FD8023',
                                borderRadius: '4px',
                              }
                            : {
                                borderRadius: '4px',
                                borderWidth: '2px',
                              }),
                        }}
                        checked={values?.permission || false}
                        name="permission"
                        value={values.permission}
                        onChange={(e) => {
                          setFieldValue('permission', e.target.checked, true);
                          setFieldTouched('permission', true, false);
                        }}
                        error={errors?.permission && touched?.permission}
                        onBlur={handleBlur}
                      />
                      {consumer && (
                        <div className=" w-4/5 h-full bg-navy-600 p-3 ml-auto">
                          <p className="text-xs block mt-px text-grey-2232 font-roboto font-normal tracking-wide ">
                            I have read the
                            <a
                              className="underline text-sm text-orange-1100 tracking-wide mx-1"
                              href="/consent"
                              target="_blank"
                            >
                              consent
                            </a>
                            {showMore ? (
                              <span>
                                and I appoint and allow FINCITY to access my
                                credit information from Credit Information
                                Companies in order to understand my credit
                                worthiness and thereinafter provide personalised
                                values which would help them generate the Credit
                                Information Report, Credit Score and Credit
                                Analysis. I/We hereby authorize FINCITY & its
                                affiliates including banking partners to call or
                                SMS and/or WhatsApp with reference to my
                                application or in relation to any of FINCITY
                                products, notwithstanding anything to the
                                contrary that may be contained anywhere,
                                including any registration for DNC/ NDNC.
                                {
                                  <span
                                    className="text-green-1000 text-xs font-roboto font-semibold cursor-pointer"
                                    onClick={() => setShowMore(false)}
                                  >
                                    less
                                  </span>
                                }
                              </span>
                            ) : (
                              <>
                                <span>...</span>
                                <span
                                  className="text-green-1000 text-xs font-roboto font-semibold cursor-pointer"
                                  onClick={() => setShowMore(true)}
                                >
                                  more
                                </span>
                              </>
                            )}
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                  <button
                    id="submit"
                    onClick={() => {
                      if (values.step !== 'signUp')
                        localStorage.setItem('login', true);
                      else localStorage.setItem('login', false);
                    }}
                    className={'submitButton w-full '}
                    type="submit"
                    disabled={!_.isEmpty(errors)}
                  >
                    {values.step === 'signUp' ? 'SIGN UP' : 'SIGN IN'}
                  </button>

                  <ThrowError />
                  {values?.step == 'signUp' && (
                    <TruCaller
                      loginPrefix="getstarted"
                      loginSuffix="register"
                      skipOption="later"
                      type="btmsheet"
                      title="Sign Up"
                      handleTruCallerData={handleTruCallerData}
                      istruCallerPresent={istruCallerPresent}
                      setIsTrueCallerPresent={setIsTrueCallerPresent}
                      setTrackId={(e) => setFieldValue('reqId', e)}
                    ></TruCaller>
                  )}
                </div>
              </Fragment>
            ) : (
              <ForgotPassword
                setFieldTouched={setFieldTouched}
                submitHandler={() => {
                  handleSubmit();
                }}
              />
            )}
          </div>
        </div>
      </div>
      {values.step === 'signUp' && (
        <div
          className={`md:hidden ${
            typeof istruCallerPresent == 'undefined' && 'wrap-blocker'
          }`}
        />
      )}
    </div>
  );
};

export default withErrorHandler(RegisterForm);
